module.exports = __webpack_public_path__ + "img/carousel-left.84cb657d.png";